<form [formGroup]="form">
  <div class="p-fluid grid">
    <div class="field col-12 d-flex flex-column">
      <label for="instituicao">Instituição de Ensino</label>
      <p-select id="instituicao" appendTo="body" [filter]="true" [options]="InstEnsino" optionLabel="nome"
        optionValue="id" placeholder="Seleccione a instituição" formControlName="instituicao"></p-select>
      <small *ngIf="form.get('instituicao')?.touched && form.get('instituicao')?.invalid" class="error-message">
        Instituição é obrigatória.
      </small>
    </div>
    <div class="field col-12 d-flex flex-column">
      <label for="nome">Estudante</label>
      <p-select [filter]="true" [showClear]="true" appendTo="body" id="nome" formControlName="estudanteID"
        [options]="estudantes" optionLabel="nome" optionValue="id" placeholder="Seleccione o estudante"
        class="w-full"></p-select>
      <div *ngIf="form.get('nome')?.touched && form.get('nome')?.invalid">
        <small *ngIf="form.get('nome')?.errors?.['required']" class="error-message">Nome do estudante é
          obrigatório.</small>
      </div>
    </div>

    <div class="field col-12 d-flex flex-column gap-2" *ngIf="form.get('estudanteID')?.value">
      <ng-container *ngIf="pagination.data?.length; else emptyTemplate">
        <span>Tipo de Bolsa: {{bolsa?.tipoBolsaDescricao}} </span>
        <span>Instituição Gestora: {{bolsa?.instituicaoGestora?.nome}} </span>
        <span>Area de conhecimento: {{bolsa?.areaProgramaFormacao?.areaFormacao?.designacao}} </span>
        <span *ngIf="form.get('valores')?.value">Valor (Bolsa): <strong>{{ form.get('valores')?.value }}</strong></span>
        <span *ngIf="form.get('moeda')?.value">Moeda: <strong>{{ form.get('moeda')?.value }}</strong></span>
      </ng-container>
      <ng-template #emptyTemplate>
        <div class="no-data">
          <app-data-void titulo="Nehum auxílio de Formação encontrada"
            descricao="Clique em adicionar auxílio para criar uma."></app-data-void>
        </div>
      </ng-template>
    </div>

    <div class="field col-12 d-flex flex-column">
      <label for="motivo">Motivo (artigo 71.º do Regulamento de Financiamento de Formação Superior...)</label>
      <p-select [filter]="true" [showClear]="true" appendTo="body" id="motivo" formControlName="motivo"
        [options]="cancelamentoMotivoOptions" optionLabel="label" placeholder="Seleccione o motivo"
        class="w-full"></p-select>
      <div *ngIf="form.get('motivo')?.touched && form.get('motivo')?.invalid">
        <small *ngIf="form.get('motivo')?.errors?.['required']" class="error-message">Motivo do cancelamento é
          obrigatório.</small>
      </div>
    </div>

    <div class="field col-12 d-flex flex-column">
      <label for="observacao">Observação</label>
      <textarea name="observacao" formControlName="observacao" pTextarea id="observacao"></textarea>
      <div *ngIf="form.get('observacao')?.touched && form.get('observacao')?.invalid">
        <small *ngIf="form.get('observacao')?.errors?.['required']" class="error-message">Observação
          obrigatório.</small>
      </div>
    </div>

    <div class="field col-12 d-flex flex-column">
      <label for="valorBolsa">Valor da Bolsa</label>
      <input id="valorBolsa" class="input-number-hide-arrow" placeholder="800,00" type="text" pInputText
        formControlName="valores" />
      <div *ngIf="form.get('valores')?.touched && form.get('valores')?.invalid">
        <small *ngIf="form.get('valores')?.errors?.['required']">Valor da Bolsa é obrigatório.</small>
      </div>
    </div>

    <div class="field col-12 d-flex flex-column" *ngIf="form.get('valores')?.value">
      <label for="valorExtenso">Valor Extenso da Bolsa</label>
      <input id="valorExtenso" class="input-number-hide-arrow" placeholder="Mil e duzentos e oitenta e seis" type="text"
        pInputText formControlName="valoresextenso" />
      <div *ngIf="form.get('valoresextenso')?.touched && form.get('valoresextenso')?.invalid">
        <small *ngIf="form.get('valoresextenso')?.errors?.['required']">Valor Extenso é obrigatório.</small>
      </div>
    </div>
  </div>
</form>